<template>
  <div class="dashboard-va-main" style="padding: 0px 20px !important;">
    <div class="dashboard-va-top">
      <div class="dashboard-va-top__box shadow-sp">
        <p>Total Vendor</p>
        <p>{{ $store.state.monitoringStore.total_vendor }}</p>
        <!-- <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_active ? $store.state.vaStore.total_vendor_active : 0}}</p>
        <p v-else>memuat...</p> -->
      </div>
      <div class="dashboard-va-top__box shadow-sp">
        <p>Vendor Complete</p>
        <p>{{ $store.state.monitoringStore.vendor_complete }}</p>
        <!-- <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_jasa_inti ? $store.state.vaStore.total_vendor_jasa_inti : 0}}</p>
        <p v-else>memuat...</p> -->
      </div>
      <div class="dashboard-va-top__box shadow-sp">
        <p>Vendor Expired Soon</p>
        <p>{{ $store.state.monitoringStore.vendor_expire_soon }}</p>
        <!-- <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_non_inti ? $store.state.vaStore.total_vendor_non_inti : 0}}</p>
        <p v-else>memuat...</p> -->
      </div>
      <div class="dashboard-va-top__box shadow-sp">
        <p>Vendor Expired</p>
        <p>{{ $store.state.monitoringStore.vendor_expired }}</p>
        <!-- <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_national ? $store.state.vaStore.total_vendor_national : 0}}</p>
        <p v-else>memuat...</p> -->
      </div>
      <div class="dashboard-va-top__box shadow-sp">
        <p>Vendor Not Complete</p>
        <p>{{ $store.state.monitoringStore.vendor_not_complete }}</p>
        <!-- <p v-if="!$store.state.vaStore.header_loading">{{ $store.state.vaStore.total_vendor_inter ? $store.state.vaStore.total_vendor_inter : 0}}</p>
        <p v-else>memuat...</p> -->
      </div>
    </div>
    <div class="dashboard-va-bottom">
      <div class="dashboard-main__left">
        <VendorLegalDokumen style="height: 100%;" />
        <!-- <right-bottom /> -->
      </div>
      <div
        class="dashboard-main__right"
        style="gap: 1rem;
    "
      >
        <div class="dashboard-top">
          <top-left />
          <top-right />
        </div>
        <div
          class="flex-row"
          style="height: 100%; gap: 1rem;
      "
        >
          <DetailSioByVendor />
          <DetailExpiredSoonActivity />
          <DetailExpiredSoonKPLH />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    VendorLegalDokumen: () =>
      import(
        '@/components/dashboard/main-monitoring/left-content/vendor-legal-dokumen.vue'
      ),
    TopLeft: () =>
      import('@/components/dashboard/main-monitoring/top-right/sio-chart.vue'),
    TopRight: () =>
      import(
        '@/components/dashboard/main-monitoring/top-right/k3l-kplh-status.vue'
      ),
    DetailSioByVendor: () =>
      import(
        '@/components/dashboard/main-monitoring/bottom-right/detail-sio-vendor.vue'
      ),
    DetailExpiredSoonActivity: () =>
      import(
        '@/components/dashboard/main-monitoring/bottom-right/detail-expired-activity.vue'
      ),
    DetailExpiredSoonKPLH: () =>
      import(
        '@/components/dashboard/main-monitoring/bottom-right/detail-expired-kplh-k3l.vue'
      ),
  },
  data() {
    return {
      header: [
        {
          desc: 'Total Vendor',
          value: 2000,
        },
        {
          desc: 'Vendor Complete',
          value: 1500,
        },
        {
          desc: 'Vendor Expired Soon',
          value: 250,
        },
        {
          desc: 'Vendor Expired',
          value: 100,
        },
        {
          desc: 'Vendor Not Complete',
          value: 150,
        },
      ],
    }
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 33%;
  height: 100%;
  position: relative;
}
.region-list {
  width: 60%;
  height: 100%;
  overflow-y: auto;
}
</style>
